import React from "react";
import { FIXED_CONTAINER } from "./assets";
import styles from './FixedContainer.module.scss';
import { downloadApk, DownloadSimulator } from "./Helper";
export default function FixedContainer() {
    const onClickDownloadSimulator = () => {
        DownloadSimulator();
    }
    const onClickDownload=()=>{
        downloadApk();
    }
    return (
        <div className={styles["container"]}>
            <img src={FIXED_CONTAINER.DOWNLOAD_BACKGROUND.default} alt="Background" />
            <div className={styles["main-container"]}>
                <div className={styles["icon-container"]}>
                    <img src={FIXED_CONTAINER.ICON_1.default} alt="Icon" />
                </div>
                <div className={styles["button-container"]}>
                    <img src={FIXED_CONTAINER.BUTTON_1.default}
                        alt="Button" onClick={ onClickDownloadSimulator}
                    />
                </div>
                <div className={styles["icon-container"]}>
                    <img src={FIXED_CONTAINER.ICON_2.default} alt="Icon" />
                </div>
                <div className={styles["button-container"]}>
                    <img src={FIXED_CONTAINER.BUTTON_2.default}
                        alt="Button"
                        onClick={onClickDownload}
                    />
                </div>
            </div>
        </div>
    )
}

